module.exports = __webpack_public_path__ + "img/SGS.31de4a3c.svg";